<template>
  <div class="home">
    <div class="container">
      <!-- Hero Section -->
      <header class="hero">
        <div class="hero-content">
          <div class="avatar-section">
            <div class="avatar">
              <span class="avatar-text">{{ currentUser ? currentUser.username.charAt(0) : 'SH' }}</span>
            </div>
            <div class="user-info">
              <h1 class="welcome-text">欢迎回来</h1>
              <p class="username">{{ currentUser ? currentUser.username : '星屿小筑' }}</p>
            </div>
          </div>
          <div class="hero-stats">
            <div class="stat-item">
              <span class="stat-value">{{ userLoading ? '加载中' : userStats.completedOrders }}</span>
              <span class="stat-label">完成订单</span>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <span class="stat-value">¥{{ userLoading ? '加载中' : (userStats.monthlyEarnings || 0).toLocaleString() }}</span>
              <span class="stat-label">本月收益</span>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <span class="stat-value rank">{{ userLoading ? '加载中' : (userStats.rank ? '#' + userStats.rank : '未上榜') }}</span>
              <span class="stat-label">当前排名</span>
            </div>
          </div>
        </div>
        <div class="hero-bg"></div>
      </header>

      <!-- Carousel -->
      <section class="section carousel-section">
        <div class="carousel" @touchstart="touchStart" @touchend="touchEnd">
          <div class="carousel-wrap" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
            <div class="carousel-item" v-for="(img, idx) in carouselList" :key="idx">
              <img :src="img" alt="轮播图" />
            </div>
          </div>
          <div class="carousel-overlay">
            <div class="carousel-tag">限时活动</div>
            <h2 class="carousel-title">星屿小筑内部奖金赛</h2>
            <p class="carousel-desc">接单十单获得报名资格</p>
          </div>
          <div class="carousel-dots">
            <div class="dot" :class="{ active: idx === currentIndex }" v-for="(img, idx) in carouselList" :key="idx"></div>
          </div>
        </div>
      </section>

      <!-- Quick Actions -->
      <section class="section">
        <h3 class="section-title">快捷操作</h3>
        <div class="action-grid">
          <div class="action-card primary" @click="router.push('/hold')">
            <Zap class="action-icon" size="28" />
            <span class="action-text">接单中心</span>
          </div>
          <div class="action-card" @click="router.push('/event')">
            <Calendar class="action-icon" size="28" />
            <span class="action-text">赛事</span>
          </div>
          <div class="action-card" @click="activeTab = 'rules'">
            <FileText class="action-icon" size="28" />
            <span class="action-text">规章</span>
          </div>
          <div class="action-card" @click="router.push('/mypage')">
            <User class="action-icon" size="28" />
            <span class="action-text">个人中心</span>
          </div>
        </div>
      </section>

      <!-- Leaderboard & Rules Tabs -->
      <section class="section">
        <div class="tabs">
          <button
            class="tab-btn"
            :class="{ active: activeTab === 'weekly' }"
            @click="switchTab('weekly')"
          >
            周榜
          </button>
          <button
            class="tab-btn"
            :class="{ active: activeTab === 'daily' }"
            @click="switchTab('daily')"
          >
            日榜
          </button>
          <button
            class="tab-btn"
            :class="{ active: activeTab === 'monthly' }"
            @click="switchTab('monthly')"
          >
            月榜
          </button>
          <button
            class="tab-btn"
            :class="{ active: activeTab === 'rules' }"
            @click="switchTab('rules')"
          >
            规章
          </button>
        </div>

        <div class="tab-content" v-if="activeTab !== 'rules'">
          <div v-if="loading" class="loading-state">
            <div class="spinner"></div>
            <span>加载中...</span>
          </div>
          <div v-else-if="currentRankings.length === 0" class="empty-state">
            <Award size="48" class="empty-icon" />
            <p>暂无{{ tabLabels[activeTab] }}数据</p>
          </div>
          <div v-else class="leaderboard">
            <div class="leaderboard-card" v-for="(rank, index) in currentRankings" :key="index" :class="'rank-' + (index + 1)">
              <div class="rank-badge" :class="'badge-' + (index + 1)">{{ index + 1 }}</div>
              <div class="rank-avatar">
                <span>{{ rank.avatar }}</span>
              </div>
              <div class="rank-info">
                <span class="rank-name">{{ rank.name }}</span>
                <span class="rank-orders">{{ rank.orders }}单</span>
              </div>
              <div class="rank-earnings">
                <span class="earnings-value">¥{{ rank.earnings }}</span>
                <span class="earnings-label">{{ tabLabels[activeTab] }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="tab-content rules-content" v-else>
          <div class="rules-list">
            <div class="rule-item">
              <span class="rule-num">01</span>
              <div class="rule-text">
                <h4>严禁私加老板</h4>
                <p>严禁私加老板，老板举报可以得奖金200r，同时对私加的打手罚款200r，不论是老板主动要求加，还是打手主动要求加，只要有好友关系，都视作成立</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">02</span>
              <div class="rule-text">
                <h4>转单进度清零</h4>
                <p>转单默认之前进度清零，且进行罚款</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">03</span>
              <div class="rule-text">
                <h4>禁止未结单接新单</h4>
                <p>在有单子未结单情况下点结单去接其他单子的，罚款20r</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">04</span>
              <div class="rule-text">
                <h4>转单规则</h4>
                <p>还未开始打之前转单不作处罚，开始打之后转单，如若之前有进度，扣除所有进度，如若没有进度，或者进度退后的，按照75比1000的比例对退后部分进行罚款，并再处7r罚款处理</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">05</span>
              <div class="rule-text">
                <h4>队伍自我介绍</h4>
                <p>进队伍的时候自我介绍，格式为：板板好，我是星屿小筑的什么什么，一周三次暗测，符合流程的打手奖励50r，不符合的罚款50r</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">06</span>
              <div class="rule-text">
                <h4>接单要求</h4>
                <p>每个打手一周至少接一单，未达标的罚款10r处理，一个月未接单者清退</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">07</span>
              <div class="rule-text">
                <h4>申诉渠道</h4>
                <p>若对罚款有疑问可在24小时内向管理申诉</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">08</span>
              <div class="rule-text">
                <h4>禁止私单</h4>
                <p>发现私单出现在俱乐部群聊，进行罚款10r处理</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">09</span>
              <div class="rule-text">
                <h4>接单后加好友要求</h4>
                <p>接单后两分钟内老板必须接收到好友申请，就算要找搭子，也加了老板进房间和老板说明情况再找，没有达到要求的，一次罚款10r</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">10</span>
              <div class="rule-text">
                <h4>结单流程要求</h4>
                <p>结单之后不要直接退房间，炸单多或这单表现不好就诚意一点给板板道歉赔礼，打得好就和板板说："板板那我们这单就结单了哈，礼貌的祝板板天天摸大红，板板再见"。俱乐部每周会进行5次抽查，安排暗测，每周暗测完群内公示测试打手名单以及暗测情况并进行奖罚，如果没有按照流程，会罚款50r，同样如果按照流程做的，俱乐部会奖励50r</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">11</span>
              <div class="rule-text">
                <h4>结单客诉责任</h4>
                <p>若结单之后板板客诉，如客诉成立，客诉造成的赔偿损失由打手承担</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">13</span>
              <div class="rule-text">
                <h4>转单规章</h4>
                <p>新打手上号之前原打手（至少一个）必须在房间里面呆着，陪老板聊天，打得不好就表示歉意、道歉、认错，打得好就和老板闲聊吹吹牛，直到新打手接单加老板。转单之后发现新打手接单后没在两分钟内上号+老板，原打手可以保留截屏证据向管理反馈，奖金50r；同样新打手加老板之后如果发现老板没在队伍房间截图向管理反馈，同样能拿到50r反馈奖金，违规的任意一方罚款40r</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">14</span>
              <div class="rule-text">
                <h4>客诉率处理</h4>
                <p>每周一次，对客诉率25%以上的打手进行扣押清退处理</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">15</span>
              <div class="rule-text">
                <h4>客诉罚款标准</h4>
                <p>每次客诉如果证实后，客诉炸单多（5炸3及以上成立）罚款20r，客诉私藏100r罚款，客诉态度不好罚款20r，打手需出示证据；客诉压力老板或者压力队友导致体验很差，罚款50r，打手申诉需出示录屏证据</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">16</span>
              <div class="rule-text">
                <h4>周榜比赛奖励</h4>
                <p>周榜前五，可以参与比赛，只有第一名能拿奖金，奖金500r</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">17</span>
              <div class="rule-text">
                <h4>零客诉榜奖励</h4>
                <p>零客诉榜前五（接十单以上），一人100r每周</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">18</span>
              <div class="rule-text">
                <h4>禁止私单</h4>
                <p>和老板说下单走私下不走平台，罚款200r，老板那面有渠道可以进行举报，举报奖励200r</p>
              </div>
            </div>
            <div class="rule-item">
              <span class="rule-num">19</span>
              <div class="rule-text">
                <h4>接单超时处理</h4>
                <p>接单了不打的或者找不到打手的及时转出来，超过10分钟罚款10r</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- Bottom Navigation -->
    <nav class="bottom-nav">
      <div class="nav-item active" @click="router.push('/')">
        <Home class="nav-icon" size="22" />
        <span class="nav-text">首页</span>
      </div>
      <div class="nav-item" @click="router.push('/hold')">
        <Zap class="nav-icon" size="22" />
        <span class="nav-text">接单</span>
      </div>
      <div class="nav-item" @click="router.push('/mypage')">
        <User class="nav-icon" size="22" />
        <span class="nav-text">我的</span>
      </div>
    </nav>
  </div>
</template>

<script setup>
/* eslint-disable vue/multi-word-component-names */
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { Home, Zap, User, Calendar, Award, FileText } from 'lucide-vue-next'
import { supabase } from '@/utils/supabase'
import { getSecureStorage, SECURE_STORAGE_KEY, PLATFORM_TABLE_MAP } from '@/utils/security'

const router = useRouter()

const activeTab = ref('weekly')
const rankings = ref([])
const weeklyRankings = ref([])
const dailyRankings = ref([])
const monthlyRankings = ref([])
const loading = ref(false)
const userLoading = ref(false)
const currentUser = ref(null)
const userStats = ref({
  completedOrders: 0,
  monthlyEarnings: 0,
  rank: 0
})

const tabLabels = {
  weekly: '周收益',
  daily: '日收益',
  monthly: '月收益'
}

const currentRankings = computed(() => {
  switch (activeTab.value) {
    case 'weekly': return weeklyRankings.value
    case 'daily': return dailyRankings.value
    case 'monthly': return monthlyRankings.value
    default: return weeklyRankings.value
  }
})

async function switchTab(tab) {
  activeTab.value = tab
  
  // 根据标签类型加载对应的排行榜数据
  if (tab === 'weekly') {
    await fetchWeeklyLeaderboard()
  } else if (tab === 'daily') {
    await fetchDailyLeaderboard()
  } else if (tab === 'monthly') {
    await fetchMonthlyLeaderboard()
  }
}

// 获取用户信息和统计数据
async function fetchUserInfo() {
  userLoading.value = true
  try {
    // 从安全存储获取登录信息
    const storedUser = getSecureStorage(SECURE_STORAGE_KEY)
    if (storedUser) {
      currentUser.value = storedUser
      const platform = storedUser.platform || 'mobile_delta'
      const tables = PLATFORM_TABLE_MAP[platform]
      
      // 计算本月开始时间
      const now = new Date()
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1)
      
      // 获取用户的完成订单
      const { data: completedOrders, error: ordersError } = await supabase
        .from(tables.orders)
        .select('price, status, finished_at, created_at')
        .eq('handler_id', currentUser.value.username)
        .in('status', ['completed', 'finished', 'pending_review'])
      
      if (ordersError) {
        console.error('获取订单数据失败:', ordersError)
      } else {
        // 计算总完成订单数
        userStats.value.completedOrders = completedOrders.length
        
        // 计算本月收益
        const monthlyOrders = completedOrders.filter(order => {
          const orderDate = new Date(order.finished_at || order.created_at)
          return orderDate >= startOfMonth
        })
        
        userStats.value.monthlyEarnings = Math.floor(
          monthlyOrders.reduce((sum, order) => sum + Number(order.price) * 0.83, 0)
        )
      }
      
      // 计算用户排名（基于周榜数据）
      if (rankings.value.length > 0) {
        const userRank = rankings.value.findIndex(
          rank => rank.name === currentUser.value.username
        )
        if (userRank !== -1) {
          userStats.value.rank = userRank + 1
        } else {
          // 如果用户不在周榜中，计算排名
          const { data: allOrders, error } = await supabase
            .from(tables.orders)
            .select('handler_id, price')
            .in('status', ['completed', 'finished', 'pending_review'])
          
          if (!error) {
            const allPlayerEarnings = {}
            allOrders.forEach(order => {
              if (order.handler_id) {
                if (!allPlayerEarnings[order.handler_id]) {
                  allPlayerEarnings[order.handler_id] = 0
                }
                allPlayerEarnings[order.handler_id] += Math.floor(Number(order.price) * 0.83)
              }
            })
            
            const sortedPlayers = Object.entries(allPlayerEarnings)
              .map(([name, earnings]) => ({ name, earnings }))
              .sort((a, b) => b.earnings - a.earnings)
            
            const userIndex = sortedPlayers.findIndex(
              player => player.name === currentUser.value.username
            )
            userStats.value.rank = userIndex !== -1 ? userIndex + 1 : 0
          }
        }
      }
    }
  } catch (error) {
    console.error('获取用户信息失败:', error)
  } finally {
    userLoading.value = false
  }
}

// 获取日榜数据
async function fetchDailyLeaderboard() {
  loading.value = true
  try {
    const storedUser = getSecureStorage(SECURE_STORAGE_KEY)
    const platform = storedUser?.platform || 'mobile_delta'
    const tables = PLATFORM_TABLE_MAP[platform]

    const now = new Date()
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const endOfDay = new Date(startOfDay)
    endOfDay.setDate(endOfDay.getDate() + 1)
    endOfDay.setMilliseconds(-1)

    const [ordersResult, xianyuResult] = await Promise.all([
      supabase
        .from(tables.orders)
        .select('handler_id, price, finished_at')
        .in('status', ['completed', 'finished', 'pending_review'])
        .gte('finished_at', startOfDay.toISOString())
        .lte('finished_at', endOfDay.toISOString()),
      supabase
        .from(tables.xianyu_order)
        .select('player, price, fish_time')
        .in('status', ['finished', 'completed', 'pending_review'])
        .gte('fish_time', startOfDay.toISOString())
        .lte('fish_time', endOfDay.toISOString())
    ])

    if (ordersResult.error) console.error('获取日榜订单失败:', ordersResult.error)
    if (xianyuResult.error) console.error('获取日榜闲鱼订单失败:', xianyuResult.error)

    const ordersData = ordersResult.data || []
    const xianyuData = xianyuResult.data || []

    const playerEarnings = {}
    ordersData.forEach(order => {
      if (order.handler_id) {
        if (!playerEarnings[order.handler_id]) {
          playerEarnings[order.handler_id] = {
            name: order.handler_id,
            earnings: 0,
            orders: 0,
            avatar: order.handler_id.charAt(0)
          }
        }
        playerEarnings[order.handler_id].earnings += Math.floor(Number(order.price) * 0.83)
        playerEarnings[order.handler_id].orders += 1
      }
    })

    xianyuData.forEach(order => {
      if (order.player) {
        if (!playerEarnings[order.player]) {
          playerEarnings[order.player] = {
            name: order.player,
            earnings: 0,
            orders: 0,
            avatar: order.player.charAt(0)
          }
        }
        playerEarnings[order.player].earnings += Math.floor(Number(order.price) * 0.83)
        playerEarnings[order.player].orders += 1
      }
    })

    const sortedRankings = Object.values(playerEarnings)
      .sort((a, b) => b.earnings - a.earnings)
      .slice(0, 5)

    dailyRankings.value = sortedRankings.map(item => ({
      ...item,
      earnings: item.earnings.toLocaleString()
    }))

  } catch (error) {
    console.error('获取日榜数据失败:', error)
  } finally {
    loading.value = false
  }
}

// 获取月榜数据
async function fetchMonthlyLeaderboard() {
  loading.value = true
  try {
    const storedUser = getSecureStorage(SECURE_STORAGE_KEY)
    const platform = storedUser?.platform || 'mobile_delta'
    const tables = PLATFORM_TABLE_MAP[platform]

    const now = new Date()
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1)
    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1)
    endOfMonth.setMilliseconds(-1)

    console.log('月榜查询时间范围:', {
      start: startOfMonth.toISOString(),
      end: endOfMonth.toISOString()
    })

    const [ordersResult, xianyuResult] = await Promise.all([
      supabase
        .from(tables.orders)
        .select('handler_id, price, finished_at')
        .in('status', ['completed', 'finished', 'pending_review'])
        .gte('finished_at', startOfMonth.toISOString())
        .lte('finished_at', endOfMonth.toISOString()),
      supabase
        .from(tables.xianyu_order)
        .select('player, price, fish_time')
        .in('status', ['finished', 'completed', 'pending_review'])
        .gte('fish_time', startOfMonth.toISOString())
        .lte('fish_time', endOfMonth.toISOString())
    ])

    if (ordersResult.error) console.error('获取月榜订单失败:', ordersResult.error)
    if (xianyuResult.error) console.error('获取月榜闲鱼订单失败:', xianyuResult.error)

    const ordersData = ordersResult.data || []
    const xianyuData = xianyuResult.data || []

    console.log('月榜数据:', {
      普通订单数: ordersData.length,
      闲鱼订单数: xianyuData.length
    })

    const playerEarnings = {}
    ordersData.forEach(order => {
      if (order.handler_id) {
        if (!playerEarnings[order.handler_id]) {
          playerEarnings[order.handler_id] = {
            name: order.handler_id,
            earnings: 0,
            orders: 0,
            avatar: order.handler_id.charAt(0)
          }
        }
        playerEarnings[order.handler_id].earnings += Math.floor(Number(order.price) * 0.83)
        playerEarnings[order.handler_id].orders += 1
      }
    })

    xianyuData.forEach(order => {
      if (order.player) {
        if (!playerEarnings[order.player]) {
          playerEarnings[order.player] = {
            name: order.player,
            earnings: 0,
            orders: 0,
            avatar: order.player.charAt(0)
          }
        }
        playerEarnings[order.player].earnings += Math.floor(Number(order.price) * 0.83)
        playerEarnings[order.player].orders += 1
      }
    })

    const sortedRankings = Object.values(playerEarnings)
      .sort((a, b) => b.earnings - a.earnings)
      .slice(0, 5)

    console.log('月榜排行结果:', sortedRankings)

    monthlyRankings.value = sortedRankings.map(item => ({
      ...item,
      earnings: item.earnings.toLocaleString()
    }))

  } catch (error) {
    console.error('获取月榜数据失败:', error)
  } finally {
    loading.value = false
  }
}

// 获取周榜数据
async function fetchWeeklyLeaderboard() {
  loading.value = true
  try {
    const storedUser = getSecureStorage(SECURE_STORAGE_KEY)
    const platform = storedUser?.platform || 'mobile_delta'
    const tables = PLATFORM_TABLE_MAP[platform]

    const now = new Date()
    const dayOfWeek = now.getDay() || 7
    const startOfWeek = new Date(now)
    startOfWeek.setDate(now.getDate() - dayOfWeek + 1)
    startOfWeek.setHours(0, 0, 0, 0)

    const endOfWeek = new Date(startOfWeek)
    endOfWeek.setDate(startOfWeek.getDate() + 6)
    endOfWeek.setHours(23, 59, 59, 999)

    const [ordersResult, xianyuResult] = await Promise.all([
      supabase
        .from(tables.orders)
        .select('handler_id, price, finished_at')
        .in('status', ['completed', 'finished', 'pending_review'])
        .gte('finished_at', startOfWeek.toISOString())
        .lte('finished_at', endOfWeek.toISOString()),
      supabase
        .from(tables.xianyu_order)
        .select('player, price, fish_time')
        .in('status', ['finished', 'completed', 'pending_review'])
        .gte('fish_time', startOfWeek.toISOString())
        .lte('fish_time', endOfWeek.toISOString())
    ])

    if (ordersResult.error) console.error('获取周榜订单失败:', ordersResult.error)
    if (xianyuResult.error) console.error('获取周榜闲鱼订单失败:', xianyuResult.error)

    const ordersData = ordersResult.data || []
    const xianyuData = xianyuResult.data || []

    const playerEarnings = {}
    ordersData.forEach(order => {
      if (order.handler_id) {
        if (!playerEarnings[order.handler_id]) {
          playerEarnings[order.handler_id] = {
            name: order.handler_id,
            earnings: 0,
            orders: 0,
            avatar: order.handler_id.charAt(0)
          }
        }
        playerEarnings[order.handler_id].earnings += Math.floor(Number(order.price) * 0.83)
        playerEarnings[order.handler_id].orders += 1
      }
    })

    xianyuData.forEach(order => {
      if (order.player) {
        if (!playerEarnings[order.player]) {
          playerEarnings[order.player] = {
            name: order.player,
            earnings: 0,
            orders: 0,
            avatar: order.player.charAt(0)
          }
        }
        playerEarnings[order.player].earnings += Math.floor(Number(order.price) * 0.83)
        playerEarnings[order.player].orders += 1
      }
    })

    const sortedRankings = Object.values(playerEarnings)
      .sort((a, b) => b.earnings - a.earnings)
      .slice(0, 5)

    weeklyRankings.value = sortedRankings.map(item => ({
      ...item,
      earnings: item.earnings.toLocaleString()
    }))

    rankings.value = weeklyRankings.value

  } catch (error) {
    console.error('获取周榜数据失败:', error)
  } finally {
    loading.value = false
  }
}

onMounted(async () => {
  autoPlay()
  await Promise.all([
    fetchWeeklyLeaderboard(),
    fetchDailyLeaderboard(),
    fetchMonthlyLeaderboard(),
    fetchUserInfo()
  ])
})
onUnmounted(() => clearInterval(timer))

const carouselList = ref([
  new URL('@/assets/img/carousel_img/1.jpg', import.meta.url).href,
  new URL('@/assets/img/carousel_img/2.jpg', import.meta.url).href,
])

const currentIndex = ref(0)
let timer = null
const startX = ref(0)

function autoPlay() {
  timer = setInterval(() => {
    currentIndex.value++
    if (currentIndex.value >= carouselList.value.length) currentIndex.value = 0
  }, 4000)
}

function touchStart(e) {
  startX.value = e.changedTouches[0].clientX
  clearInterval(timer)
}
function touchEnd(e) {
  const endX = e.changedTouches[0].clientX
  const diff = endX - startX.value
  if (diff > 50) {
    currentIndex.value--
    if (currentIndex.value < 0) currentIndex.value = carouselList.value.length - 1
  }
  if (diff < -50) {
    currentIndex.value++
    if (currentIndex.value >= carouselList.value.length) currentIndex.value = 0
  }
  autoPlay()
}
</script>

<style scoped>
.home {
  background: var(--color-bg-primary);
  min-height: 100vh;
  padding-bottom: 90px;
  color: var(--color-text-primary);
}

.container {
  max-width: 480px;
  margin: 0 auto;
  padding: 0 16px;
}

/* Hero Section */
.hero {
  position: relative;
  padding: 24px 0 20px;
  overflow: hidden;
}

.hero-bg {
  position: absolute;
  top: 0;
  left: -20px;
  right: -20px;
  height: 160px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(139, 92, 246, 0.08) 100%);
  border-radius: 0 0 50% 50%;
  z-index: 0;
}

.hero-content {
  position: relative;
  z-index: 1;
}

.avatar-section {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
}

.avatar {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  background: var(--color-accent-gradient);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.4);
}

.avatar-text {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}

.user-info {
  flex: 1;
}

.welcome-text {
  font-size: 13px;
  color: var(--color-text-secondary);
  font-weight: 400;
  margin-bottom: 2px;
}

.username {
  font-size: 20px;
  font-weight: 700;
  color: var(--color-text-primary);
}

.hero-stats {
  display: flex;
  align-items: center;
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  padding: 16px 20px;
  border: 1px solid var(--color-border);
}

.stat-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-value {
  font-size: 18px;
  font-weight: 700;
  color: var(--color-text-primary);
  margin-bottom: 2px;
}

.stat-value.rank {
  color: var(--color-accent-primary);
}

.stat-label {
  font-size: 11px;
  color: var(--color-text-muted);
}

.stat-divider {
  width: 1px;
  height: 30px;
  background: var(--color-border);
}

/* Sections */
.section {
  margin-bottom: 24px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.section-title {
  font-size: 17px;
  font-weight: 600;
  color: var(--color-text-primary);
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-icon {
  color: var(--color-accent-primary);
}

.section-link {
  font-size: 13px;
  color: var(--color-accent-primary);
  font-weight: 500;
}

.section-badge {
  font-size: 12px;
  padding: 4px 10px;
  background: rgba(99, 102, 241, 0.15);
  color: var(--color-accent-primary);
  border-radius: 20px;
  font-weight: 500;
}

/* Carousel */
.carousel-section {
  margin-bottom: 28px;
}

.carousel {
  width: 100%;
  height: 160px;
  border-radius: var(--radius-xl);
  overflow: hidden;
  position: relative;
  box-shadow: var(--shadow-lg);
}

.carousel-wrap {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform var(--transition-slow);
}

.carousel-item {
  width: 100%;
  height: 100%;
  flex-shrink: 0;
}

.carousel-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background: linear-gradient(to top, rgba(15, 17, 23, 0.95) 0%, transparent 100%);
}

.carousel-tag {
  display: inline-block;
  font-size: 10px;
  padding: 3px 8px;
  background: var(--color-error);
  color: #fff;
  border-radius: 4px;
  font-weight: 600;
  margin-bottom: 6px;
}

.carousel-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 4px;
}

.carousel-desc {
  font-size: 12px;
  color: var(--color-text-secondary);
}

.carousel-dots {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  gap: 6px;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.3);
  transition: var(--transition-fast);
}

.dot.active {
  background: #fff;
  width: 18px;
}

/* Action Grid */
.action-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.action-card {
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  padding: 14px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--color-border);
  transition: var(--transition-fast);
  cursor: pointer;
}

.action-card:hover {
  border-color: var(--color-border-hover);
  transform: translateY(-2px);
}

.action-card.primary {
  background: var(--color-accent-gradient);
  border: none;
  box-shadow: var(--shadow-glow);
}

.action-card.primary .action-icon,
.action-card.primary .action-text {
  color: #fff;
}

.action-icon {
  transition: var(--transition-fast);
}

.action-card.primary .action-icon {
  color: #fff;
}

.action-text {
  font-size: 11px;
  color: var(--color-text-secondary);
  font-weight: 500;
}

/* Leaderboard */
.leaderboard {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.leaderboard-card {
  display: flex;
  align-items: center;
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  padding: 12px 14px;
  border: 1px solid var(--color-border);
  transition: var(--transition-fast);
}

.leaderboard-card:hover {
  border-color: var(--color-border-hover);
}

.leaderboard-card.rank-1 {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(139, 92, 246, 0.05) 100%);
  border-color: rgba(99, 102, 241, 0.3);
}

.rank-badge {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  margin-right: 12px;
  background: var(--color-accent-gradient);
  color: #fff;
}

.rank-badge.badge-2 {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.rank-badge.badge-3 {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.rank-avatar {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--color-bg-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-secondary);
}

.rank-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.rank-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.rank-orders {
  font-size: 11px;
  color: var(--color-text-muted);
}

.rank-earnings {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}

.earnings-value {
  font-size: 15px;
  font-weight: 700;
  color: var(--color-success);
}

.earnings-label {
  font-size: 10px;
  color: var(--color-text-muted);
}

/* Orders Section */
.orders-section {
  margin-bottom: 28px;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
  gap: 12px;
  color: var(--color-text-muted);
  font-size: 13px;
}

.spinner {
  width: 28px;
  height: 28px;
  border: 3px solid var(--color-border);
  border-top-color: var(--color-accent-primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 0;
  gap: 8px;
}

.empty-icon {
  font-size: 40px;
  margin-bottom: 8px;
  opacity: 0.5;
}

.empty-text {
  font-size: 15px;
  font-weight: 500;
  color: var(--color-text-secondary);
}

.empty-hint {
  font-size: 12px;
  color: var(--color-text-muted);
}

.order-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.order-card {
  background: var(--color-bg-card);
  border-radius: var(--radius-xl);
  padding: 16px;
  border: 1px solid var(--color-border);
  transition: var(--transition-fast);
}

.order-card:hover {
  border-color: var(--color-accent-primary);
  box-shadow: 0 0 20px rgba(99, 102, 241, 0.15);
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--color-border);
}

.order-shop {
  display: flex;
  align-items: center;
  gap: 8px;
}

.shop-tag {
  font-size: 10px;
  padding: 3px 6px;
  background: var(--color-accent-gradient);
  color: #fff;
  border-radius: 4px;
  font-weight: 600;
}

.shop-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.order-price {
  display: flex;
  align-items: baseline;
}

.price-symbol {
  font-size: 13px;
  color: var(--color-success);
  font-weight: 600;
}

.price-value {
  font-size: 20px;
  font-weight: 700;
  color: var(--color-success);
}

.order-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 14px;
}

.order-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.order-label {
  font-size: 12px;
  color: var(--color-text-muted);
  min-width: 40px;
}

.order-value {
  font-size: 13px;
  color: var(--color-text-secondary);
  flex: 1;
}

.order-value.map {
  color: var(--color-accent-primary);
  font-weight: 500;
}

.order-value.highlight {
  color: var(--color-text-primary);
  font-weight: 500;
}

.order-value.urgent {
  color: var(--color-error);
  font-weight: 500;
}

.order-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid var(--color-border);
}

.order-status {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
}

/* Tabs */
.tabs {
  display: flex;
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  padding: 4px;
  margin-bottom: 16px;
  border: 1px solid var(--color-border);
}

.tab-btn {
  flex: 1;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text-muted);
  border-radius: var(--radius-md);
  transition: var(--transition-fast);
  display: flex;
  align-items: center;
  gap: 6px;
}

.tab-icon {
  transition: var(--transition-fast);
}

.tab-btn.active .tab-icon {
  color: #fff;
}

.tab-btn.active {
  background: var(--color-accent-gradient);
  color: #fff;
  box-shadow: var(--shadow-sm);
}

.tab-content {
  animation: fadeIn var(--transition-normal) forwards;
}

/* Notice List */
.notice-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.notice-item {
  display: flex;
  gap: 12px;
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  padding: 14px;
  border: 1px solid var(--color-border);
  transition: var(--transition-fast);
}

.notice-item:hover {
  border-color: var(--color-border-hover);
}

.notice-badge {
  font-size: 10px;
  padding: 4px 8px;
  background: rgba(239, 68, 68, 0.15);
  color: var(--color-error);
  border-radius: 4px;
  font-weight: 600;
  height: fit-content;
}

.notice-badge.warning {
  background: rgba(245, 158, 11, 0.15);
  color: var(--color-warning);
}

.notice-content {
  flex: 1;
}

.notice-content h4 {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: 4px;
}

.notice-content p {
  font-size: 12px;
  color: var(--color-text-secondary);
  line-height: 1.5;
  margin-bottom: 6px;
}

.notice-time {
  font-size: 11px;
  color: var(--color-text-muted);
}

/* Rules List */
.rules-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rule-item {
  display: flex;
  gap: 14px;
  align-items: flex-start;
}

.rule-num {
  font-size: 20px;
  font-weight: 800;
  color: var(--color-accent-primary);
  opacity: 0.5;
  line-height: 1;
  min-width: 28px;
}

.rule-text {
  flex: 1;
}

.rule-text h4 {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: 4px;
}

.rule-text p {
  font-size: 12px;
  color: var(--color-text-secondary);
  line-height: 1.5;
}

/* Bottom Navigation */
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 70px;
  background: rgba(15, 17, 23, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-top: 1px solid var(--color-border);
  z-index: 999;
  padding-bottom: env(safe-area-inset-bottom);
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 20px;
  border-radius: var(--radius-md);
  transition: var(--transition-fast);
  cursor: pointer;
}

.nav-icon {
  transition: var(--transition-fast);
}

.nav-text {
  font-size: 11px;
  font-weight: 500;
  color: var(--color-text-muted);
  transition: var(--transition-fast);
}

.nav-item.active {
  background: rgba(99, 102, 241, 0.1);
}

.nav-item.active .nav-icon {
  transform: scale(1.1);
}

.nav-item.active .nav-text {
  color: var(--color-accent-primary);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
